var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"brands-list"},_vm._l((_vm.BRANDS),function(brand,index){return _c('div',{key:index},[_c('a',{attrs:{"href":_vm.webUrl(brand.brandCode)}},[_vm._v(_vm._s(brand.brandName))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }